import { Store } from '@ngrx/store';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { SharedProgrammingService } from '../../common/services/shared-programming.service';
import { ProgrammingEventsState } from './../../common/services/events.service';
import { ScheduleProgrammingService } from '../../quickstarts/quickstart-schedule/services/schedule.service';
import { EVENTS_FILTER } from '../events/eventsUI.service';

@Component({
  selector: 'prg-list-by-name',
  templateUrl: './list-by-name.component.html'
})
export class ListByNameComponent implements OnInit {
  allEvents: Observable<Array<any>>;
  searchText: Observable<string>;

  @Input() creatorFilter: EVENTS_FILTER;

  constructor(
    private shared: SharedProgrammingService,
    private store: Store<{ programmingEvents: ProgrammingEventsState }>
  ) {
    this.allEvents = this.store.select(s => s.programmingEvents.programmedEvents);
    this.searchText = this.shared.searchText;
  }

  ngOnInit() {
    console.log('list-name: oninit');
    this.shared.clearError();
    this.shared.setGrouping('description');
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/list-by-name/list-by-name.component.ts